import { useColorMode } from './useColorMode.js';
var useColorModeValue = function useColorModeValue(lightModeValue, darkModeValue) {
  var colorMode = useColorMode().colorMode;
  if (colorMode === "light") {
    return lightModeValue;
  }
  return darkModeValue;
};
export { useColorModeValue };